"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartTotal = void 0;
const React = require("react");
const List_1 = require("../../../../../../components/base/structure/List");
const Currency_1 = require("../../../../../../components/base/atoms/Currency");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "CartTotal");
/**
 * Shows total price of whole order in cart
 */
const CartTotal = ({ totalPrice }) => (React.createElement(List_1.ListItemWrapper, { className: css("") },
    React.createElement(List_1.ListItemBody, null,
        React.createElement("div", { className: css("total") },
            React.createElement("div", null, "Total"),
            React.createElement("div", { className: css("total_amount") },
                React.createElement(Currency_1.Currency, null, totalPrice))))));
exports.CartTotal = CartTotal;
//# sourceMappingURL=index.js.map